import React from 'react';
import Link from 'gatsby-link';
import Header from './header';

const PageFrame = (props) => (
    <div className="page-frame">
        
        { props.children }

        <div id="page-frame-top">
            <div id="page-frame-top-left" />
            <div id="page-frame-top-right" />
            {/* <Header siteTitle='Shane Cummerford'/> */}
        </div>
        <div id="page-frame-left" />
        <div id="page-frame-right" />
        <div id="page-frame-bottom">
            <div id="page-frame-bottom-left" />
            <div id="page-frame-bottom-right" />
        </div>

    </div>
);

export default PageFrame;


// WEBPACK FOOTER //
// ./src/components/pageFrame.js